import { useState } from 'react';

export interface TextPlaceholderCommand {
  key: string;
  label: string;
  snippet: string;
  description: string;
}

export const TEXT_SLASH_COMMANDS: TextPlaceholderCommand[] = [
  {
    key: 'vorname',
    label: '/vorname',
    snippet: '{{vorname|zusammen}}',
    description: 'Vorname des Kontakts mit Fallback',
  },
  {
    key: 'nachname',
    label: '/nachname',
    snippet: '{{nachname}}',
    description: 'Nachname des Kontakts',
  },
  {
    key: 'email',
    label: '/email',
    snippet: '{{email}}',
    description: 'E-Mail-Adresse des Kontakts',
  },
  {
    key: 'firma',
    label: '/firma',
    snippet: '{{firma}}',
    description: 'Name der zugewiesenen Firma',
  },
  {
    key: 'abmelden',
    label: '/abmelden',
    snippet: '{{abmelde_link}}',
    description: 'Abmelde-Link für DSGVO-Konformität',
  },
  {
    key: 'spintax_anrede',
    label: '/spintax-anrede',
    snippet: '{Guten Tag|Hallo|Grüezi}',
    description: 'Spintax: Zufällige Anrede für jede Mail (Spam-Schutz)',
  },
  {
    key: 'spintax_gruss',
    label: '/spintax-gruss',
    snippet: '{Beste Grüße|Freundliche Grüße|Herzliche Grüße}',
    description: 'Spintax: Zufällige Grußformel',
  },
  { key: 'datum', label: '/datum', snippet: '{{datum}}', description: 'Aktuelles Datum' },
];

export function SlashCommandToolbar({ onSelect }: { onSelect: (snippet: string) => void }) {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ margin: '4px 0 8px 0' }}>
      <button
        type="button"
        className="btn"
        data-variant="ghost"
        style={{ fontSize: 'var(--text-xs)', padding: '2px 8px' }}
        onClick={() => setOpen(!open)}
      >
        ⌨ Slash-Befehl einfügen (/)
      </button>

      {open && (
        <div
          className="card"
          style={{
            marginTop: '4px',
            padding: '8px',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '6px',
            background: 'var(--color-surface-hover)',
          }}
        >
          {TEXT_SLASH_COMMANDS.map((cmd) => (
            <button
              key={cmd.key}
              type="button"
              className="badge"
              style={{ cursor: 'pointer', padding: '4px 8px' }}
              onClick={() => {
                onSelect(cmd.snippet);
                setOpen(false);
              }}
              title={cmd.description}
            >
              <strong>{cmd.label}</strong> ({cmd.snippet})
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
